import {
  createContext,
  useContext,
  useEffect,
  useState,
  ReactNode,
} from 'react';
import { loginUser } from '@/api/modules/Login/login';
// import { useNavigate } from 'react-router-dom';
import { Loader } from '@/components/Loader/Loader';
import Maintance from '@/pages/Maintance/Maintance';

interface AuthContextType {
  isAuthenticated: boolean;
  isLoading: boolean;
}

const AuthContext = createContext<AuthContextType>({
  isAuthenticated: false,
  isLoading: true,
});

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  // const navigate = useNavigate();

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const data = await loginUser();
        // console.log('loginUser вернул:', data);
        console.log('AuthProvider data.passed:', data?.data?.data?.passed);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Authentication failed:', error);
        setIsAuthenticated(false);
        // Можно добавить редирект на страницу ошибки или показать уведомление
        // navigate('/error');
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, []);

  if (isLoading) {
    return null; // Убираем кружок, показываем только Loader с LottieAnimation на MainPage
  }

  if (!isAuthenticated) {
    return <Maintance />;
  }

  return (
    <AuthContext.Provider value={{ isAuthenticated, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
};
